import { VODCSSModules } from 'shared/utils/wix-connect';

import VideoThumbnailOverlay from 'widget/views/desktop/compact/components/video-thumbnail-overlay/video-thumbnail-overlay';

import styles from './video-list-item.styl';


// Fix for css-modules:
// Need to be separated component with css-modules decorator instead of plain jsx to provide proper styles
@VODCSSModules(styles)
export default class VideoListItem extends React.Component {

  static propTypes = {
    OverlayActionsCallbacks: React.PropTypes.func,
    onBeforeClick: React.PropTypes.func,
    onBeforePlayRequested: React.PropTypes.func,

    channelData: React.PropTypes.object,
    videoItem: React.PropTypes.object,

    width: React.PropTypes.number,
    height: React.PropTypes.number,
  };

  render() {
    const {
      channelData,
      videoItem,
      width,
      height,
      OverlayActionsCallbacks,
      onBeforeClick,
      onBeforePlayRequested,
      } = this.props;

    return (
      <div styleName="container"
           style={{ height, width }}
           data-hook="videoListThumbWrapper">
        <OverlayActionsCallbacks channelId={channelData.id}
                                 videoId={videoItem.id}
                                 videoSource={videoItem.videoSource}
                                 onBeforeClick={onBeforeClick}
                                 onBeforePlayRequested={onBeforePlayRequested}>
          <VideoThumbnailOverlay width={width}
                                 height={height}
                                 channelData={channelData}
                                 videoItem={videoItem} />
        </OverlayActionsCallbacks>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/videos/video-list-item/video-list-item.js